let selector = '.select2'
let selector_multi = '.select2_multi'

$(selector).select2({width: "100%"})
$(selector_multi).select2({width: "100%",	multiple: true})

